module.exports = __webpack_public_path__ + "img/jellyfishing.3d2d2ac1.jpg";